import { AppProviders } from './app/providers';
import { AppRouter } from './app/providers/router';
import { SkeletonProvider } from './app/providers/skeleton';
import { Toaster } from 'sonner';

declare global {
  const __APP_VERSION__: string;
}

export const App = () => {
  
  console.log(`🚀 App version: ${__APP_VERSION__}`);
  return (
    <AppProviders>
      <SkeletonProvider>
        <AppRouter />
        <Toaster
          position="top-center"
          duration={4000}
          visibleToasts={1}
          toastOptions={{
            style: {
              background: '#1E1E25',
              color: '#B9BBC5',
              border: '1px solid #FFB766',
              fontSize: '16px',
              fontFamily: 'FuturaPT',
            },
          }}
        />
      </SkeletonProvider>
    </AppProviders>
  );
};
